import loadable from '@loadable/component';
import { memo } from 'react';
import { ClientOnly } from 'remix-utils/client-only';
import type { IconComponentProps } from '../typings';

export function createAsyncIcon(
  LazyComponentFn: () => Promise<{
    default: (props: IconComponentProps) => JSX.Element;
  }>,
) {
  const La = loadable(LazyComponentFn, {
    fallback: <></>,
  });
  return memo(function (props: IconComponentProps) {
    return (
      <ClientOnly fallback={<></>}>
        {() => {
          return <La {...props} />;
        }}
      </ClientOnly>
    );
  });
}
